export const QUERY_KEY_TEAM_ROLE_ASSIGNMENTS = 'teamRoleAssignments';
